import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=03bbaaa4&scoped=true&"
import script from "./Experience.vue?vue&type=script&lang=js&"
export * from "./Experience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bbaaa4",
  null
  
)

export default component.exports